import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class ParentInfoGuard implements CanActivate {
  constructor(
    private router: Router, 
    private http: HttpClient,
    private authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    // Skip check for parent-info page itself and auth pages
    if (route.routeConfig?.path === 'parent-info' || 
        route.routeConfig?.path?.includes('auth') ||
        !this.authService.isAuthenticated() ||
        !this.authService.isAthlete()) {
      console.log('ParentInfoGuard: Skipping check for', route.routeConfig?.path);
      return of(true);
    }

    console.log('ParentInfoGuard: Checking if parent info is needed');
    
    // Check localStorage flag first (immediate response)
    if (localStorage.getItem('needs-parent-info') === 'true') {
      console.log('ParentInfoGuard: needs-parent-info flag is true, redirecting');
      this.router.navigate(['/parent-info']);
      return of(false);
    }

    // Then verify with API (for completeness)
    console.log('ParentInfoGuard: Checking with API');
    return this.http.get<any>(`${environment.baseUrl}/api/RackInsightsApi/CheckParentInfo`)
      .pipe(
        map(data => {
          console.log('ParentInfoGuard: API response', data);
          if (!data.hasParentInfo) {
            console.log('ParentInfoGuard: No parent info found, redirecting');
            localStorage.setItem('needs-parent-info', 'true');
            this.router.navigate(['/parent-info']);
            return false;
          }
          console.log('ParentInfoGuard: Parent info exists, allowing navigation');
          localStorage.removeItem('needs-parent-info');
          return true;
        }),
        catchError(error => {
          console.error('ParentInfoGuard: Error checking parent info', error);
          return of(true); // Allow navigation on error
        })
      );
  }
}
